<template>
  <Portlet
    :title="'Photo'"
    icon="image"
    class="photoMediaReview"
  >
    <LoadingPlaceholder v-if="loading" />
    <template v-if="photoRuns.length > 0">
      <div
        v-for="(item, index) in photoRuns"
        :key="`photoRun-${ index }`"
      >
        <h4 :class="index != 0 ? 'mt-3' : ''">
          <router-link
            :to="`/installation/${ item.installationId }`"
          >
            Spot {{ item.spotId }} - {{ item.spotName }}
          </router-link>
        </h4>
        <div class="row">
          <MediaReviewPhotoSessionOverview
            :run="item.firstItem"
          />
          <MediaReviewPhotoSessionOverview
            :run="item.secondItem"
          />
          <MediaReviewPhotoSessionOverview
            :run="item.thirdItem"
          />
          <MediaReviewActions
            :run="item"
          />
        </div>
      </div>
    </template>
    <p v-else>
      {{ $t('noDataAvailable') }}
    </p>    
  </Portlet>
</template>

<script>
export default {
  name: "PhotoMediaReview",
  components: {
    MediaReviewPhotoSessionOverview: () => import("@/components/MediaReview/MediaReviewPhotoSessionOverview.vue"),
    MediaReviewActions: () => import("@/components/MediaReview/MediaReviewActions.vue")
  },
  metaInfo () {
    return {
      title: "Photo"
    };
  },
  data () {
    return {
      loading: false,
      photoRuns: [],
      jobInterval: null
    };
  },
  created () {
    this.getPhotoRuns();
  },
  beforeDestroy () {
    this.clearInterval();
  },
  methods: {
    createInterval () {
      if (this.jobInterval != null) {
        this.clearInterval();
      }
      this.loading = true;
      this.jobInterval = window.setInterval(() => {
        this.getPhotoRunsJob();
      }, 1000);
    },
    clearInterval () {
      window.clearInterval(this.jobInterval);
      this.jobInterval = null;
      this.loading = false;
    },
    //#region API-calls
    getPhotoRuns () {
      this.axios
        .get(`/Media/GetPhotoMediaReview`)
        .finally(() => {
          this.createInterval();
        });
    },
    getPhotoRunsJob () {
      this.axios
        .get(`/Media/GetPhotoMediaReviewJob`)
        .then(response => {
          if (response.data && response.data.done) {
            this.clearInterval();
          }
          if (response.data && response.data.mediaReviewItems) {
            this.photoRuns = response.data.mediaReviewItems;
          }
        })
    }
  }
};
</script> 